var _style, _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBest1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_797",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 30",
    style: {
      enableBackground: "new 0 0 40 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000025436541121145249410000005994000344911259810_);}\r\n\t.st1{fill:#FF5100;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 40,
    height: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128469514570823234920000011560233574949414812_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    style: {
      clipPath: "url(#SVGID_00000128469514570823234920000011560233574949414812_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    className: "st1",
    d: "M35,0H5C2.2,0,0,2.2,0,5v20c0,2.8,2.2,5,5,5h30c2.8,0,5-2.2,5-5V5C40,2.2,37.8,0,35,0"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.1,20.4c1.1-0.6,2.4-0.3,3,0.8c0.6,1.1,0.2,2.4-0.8,3c-0.8,0.4-1.7,0.8-2.6,1.1c-0.9,0.2-1.8,0.4-2.8,0.4 c-2.9,0-5.6-1.2-7.5-3.1c-1.9-1.9-3.1-4.6-3.1-7.5c0-3,1.2-5.6,3.1-7.5c1.9-1.9,4.6-3.1,7.5-3.1s5.6,1.2,7.5,3.1 c1.9,1.9,3.1,4.6,3.1,7.5c0,1.2-1,2.2-2.2,2.2H14.2c0.3,0.8,0.8,1.6,1.4,2.1c1.1,1.1,2.7,1.8,4.4,1.8c0.6,0,1.1-0.1,1.6-0.2 C22.1,20.8,22.6,20.6,23.1,20.4L23.1,20.4z M25.8,12.8c-0.3-0.8-0.8-1.6-1.4-2.1c-1.1-1.1-2.7-1.8-4.4-1.8c-1.7,0-3.3,0.7-4.4,1.8 c-0.6,0.6-1.1,1.3-1.4,2.1L25.8,12.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBest1);
export default __webpack_public_path__ + "static/media/best1.0e3699977e0e4bf0ebe2be09b1eff478.svg";
export { ForwardRef as ReactComponent };